import {Component, inject,OnInit} from '@angular/core';
import { CartService} from '~shared/services/cart.service';
import { SessionService} from "~core/services/session.service";
import {TranslatePipe} from '@ngx-translate/core';
import {NavigateService} from "~shared/services/navigate.service";
import {
  LanguageSelectorComponent
} from "~shared/components/language-selector/language-selector.component/language-selector.component";
import { CountryDialogService } from '~core/services/ui/country-dialog.service';
import { RequiredShipmentService} from "~shared/services/required_shipment.service";


@Component({
  selector: 'app-header',
  imports: [TranslatePipe,
    LanguageSelectorComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
  standalone: true,
})
export class HeaderComponent {
  cartService = inject(CartService);
  sessionService: SessionService=inject(SessionService);
  navigateService: NavigateService=inject(NavigateService);
  private readonly countryDialog = inject(CountryDialogService);
  private readonly requiredShipmentService = inject(RequiredShipmentService);

  ngOnInit() {
    // Get the navigation entry details
    const [navigation] = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];

    // If the page was reloaded/refreshed, navigate to the home route
    if (navigation && navigation.type === 'reload') {
      console.log("Navigating to home page after reload");
      this.resetApp();
    }
  }

  constructor() {
    this.navigateService.initFromUrl();

  }

  onFilterChange(event: Event) {
    const filter = (event.target as HTMLInputElement).value;
    this.navigateService.updateSearch(filter);
  }

  get cartCount() {
    return this.cartService.itemCount;
  }

  navigateToCart() {
    this.navigateService.navigateTo('cart');
  }

  openCountryDialog(): void {
    if (!this.sessionService.requiresDestinationCountry()) return;
    console.log("Open Country Dialog", this.sessionService.CurrentCountry());
    console.log("currentiso: ", this.sessionService.CurrentCountry()?.iso_code ?? "");
    this.countryDialog.requestOpen();
  }

  resetApp() {
    this.cartService.clearCart();
    this.navigateService.resetApp();
    this.sessionService.clearCurrentZip();
    this.requiredShipmentService.requestOpen();
    // ✅ Obbligatorio ad ogni nuovo ordine per prezzi_ivati
   /* if (this.sessionService.requiresDestinationCountry()) {
      this.countryDialog.requestOpen();
    }*/
  }
}
